import { render, staticRenderFns } from "./SelectCustomers.vue?vue&type=template&id=ddc40de8"
import script from "./SelectCustomers.vue?vue&type=script&lang=js"
export * from "./SelectCustomers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports